export default "__VITE_ASSET__Bei$59LU__"